
import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const CustomTooltip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: '#1F1C37',
    boxShadow: '0 0 3em #000',
    padding: '10px 12px',
    fontSize: '1em',
    borderRadius: '10px',
  },
  arrow: {
    color: '#1F1C37',
  },
})(Tooltip);

export default CustomTooltip;
